import React from "react";
import { IconErrorCircle, IconInfoCircle, IconSuccessCircle, IconWarningCircle } from "src/Icons";
import type { Status } from "src/lib/FrontendTypes";

export interface StatusIconProps {
  color: Status;
}
const StatusIcon = (props: StatusIconProps) => {
  const { color, ...otherProps } = props;

  let Icon = <IconInfoCircle className="text-primary" />;

  if (color === "success") {
    Icon = <IconSuccessCircle className="text-success-text" />;
  } else if (color === "danger") {
    Icon = <IconErrorCircle className="text-danger-text" />;
  } else if (color === "warning") {
    Icon = <IconWarningCircle className="text-warning-text" />;
  }
  return React.cloneElement(Icon, otherProps);
};

export default StatusIcon;
